module.exports = __webpack_public_path__ + "static/img/046 5.423d6733.jpg";